import { render } from "./btn_reload.vue?vue&type=template&id=2504cf5f&scoped=true"
import script from "./btn_reload.vue?vue&type=script&lang=js"
export * from "./btn_reload.vue?vue&type=script&lang=js"

import "./btn_reload.vue?vue&type=style&index=0&id=2504cf5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2504cf5f"]])

export default __exports__